import { fetcher } from "utils";

import { IJSendSuccessResponse, IWithMeta, ApiV1ProductSerialized } from "typings";

type GetProductsId = (id: number | string) => Promise<IJSendSuccessResponse<IWithMeta<ApiV1ProductSerialized, {}>>>;

export const get__products__id: GetProductsId = id => fetcher.get(`/api/v1/products/${id}`);
